import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=135a8cd8&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=135a8cd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a8cd8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/loading/index.vue"
export default component.exports